import { useQuery } from 'react-query';
import getGeneralSettings from 'data/requests/getSettings';
import { GeneralSettings } from 'model/settings';

const useSettings = () => {
  const { data, isLoading } = useQuery<GeneralSettings>(
    'genral-settings',
    getGeneralSettings,
  );

  return { general: data, isLoading };
};

export default useSettings;
